import * as Sentry from '@sentry/browser'
import { getForexRates } from '@/services/forex-api.service.js'

const state = {
  base: [],
  rates: [],
  ratesReady: false
}

const getters = {
  forexRates: (_state) => {
    return {
      base: _state.base,
      rates: _state.rates
    }
  },
  isForexReady: (_state) => {
    return _state.ratesReady
  }
}

const mutations = {
  setBase(_state, _base) {
    _state.base = _base
  },
  setRates(_state, _rates) {
    _state.rates = _rates
  },
  setRatesReady(_state, _ratesReady) {
    _state.ratesReady = _ratesReady
  }
}

const actions = {
  async fetchForexRates(context) {
    context.commit('setRatesReady', false)
    try {
      const rates = await getForexRates()

      context.commit('setBase', rates.base)
      context.commit('setRates', rates.rates)
      context.commit('setRatesReady', true)
    } catch (e) {
      console.error(e)
      Sentry?.captureException(e)
    }
  }
}

export default {
  state,
  mutations,
  getters,
  actions,
  modules: {}
}
